import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import "bootstrap/dist/css/bootstrap.css";
import Map, { GeolocateControl, Marker } from "react-map-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import { baseUrl } from "./Components/baseUrl";

const SetLocation = () => {
    const navigate = useNavigate();
    let token;
    if (typeof window !== "undefined") {
        token = localStorage.getItem("token");
    }
    useEffect(() => {
        document.title = "پایا | افزودن فروشگاه";
        token == null && navigate("/login", { replace: true });
    }, []);
    const [stateId, setStateId] = useState("");
    const [cityId, setCityId] = useState("");
    const [region, setRegion] = useState("");
    const [district, setDistrict] = useState("");

    const [allStates, setAllStates] = useState([]);
    useEffect(() => {
        let config = {
            url: `
            https://panel.payacom.com/api/visitor/states`,
            method: "GET",
        };
        axios(config)
            .then((res) => {
                res && res.data && res.data.data && setAllStates(res.data.data);
            })
            .catch((err) => {
                toast.error(err.response.data.message, {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            });
    }, []);
    const [allCitys, setAllCitys] = useState([]);
    const getCitysHandler = (id) => {
        let config = {
            url: `https://panel.payacom.com/api/visitor/sub-location?id=${id}`,
            method: "GET",
        };
        axios(config)
            .then((res) => {
                res && res.data && res.data.data && setAllCitys(res.data.data);
            })
            .catch((err) => {
                toast.error(err.response.data.message, {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            });
    };
    const [allRegions, setAllRegions] = useState([]);
    const getRegionsHandler = (id) => {
        let config = {
            url: `https://panel.payacom.com/api/visitor/sub-location?id=${id}`,
            method: "GET",
        };
        axios(config)
            .then((res) => {
                res &&
                    res.data &&
                    res.data.data &&
                    setAllRegions(res.data.data);
            })
            .catch((err) => {
                toast.error(err.response.data.message, {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            });
    };
    const [allDestics, setAllDestics] = useState([]);
    const getDistrictHandler = (id) => {
        let config = {
            url: `https://panel.payacom.com/api/visitor/sub-location?id=${id}`,
            method: "GET",
        };
        axios(config)
            .then((res) => {
                res &&
                    res.data &&
                    res.data.data &&
                    setAllDestics(res.data.data);
            })
            .catch((err) => {
                toast.error(err.response.data.message, {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            });
    };
    // Location
    const [selectedLocation, setSelectedLocation] = useState(null);
    const handleMapClick = (event) => {
        const { lngLat } = event;
        setSelectedLocation({
            lat: lngLat.lat,
            lng: lngLat.lng,
        });
    };

    const locationHandler = (e) => {
        let data = new FormData();
        data.append("state_id", stateId);
        data.append("city_id", cityId);
        data.append("region_id", region);
        let config = {
            url: `${baseUrl}/location`,
            method: "POST",
            data: data,
        };
        axios(config)
            .then((res) => {
                // setLoading(false);
                toast.success(res.data.message, {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                navigate("/");
            })
            .catch((err) => {
                // setLoading(false);
                console.log(err);
                // toast.error(err.response.data.message, {
                //     position: "top-center",
                //     autoClose: 5000,
                //     hideProgressBar: false,
                //     closeOnClick: true,
                //     pauseOnHover: true,
                //     draggable: true,
                //     progress: undefined,
                // });
            });
    };
    return (
        <div className="container">
            <div className="location-main">
                <svg
                    width="125"
                    height="125"
                    viewBox="0 0 125 125"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        opacity="0.4"
                        d="M62.5 69.9478C71.4746 69.9478 78.75 62.6724 78.75 53.6978C78.75 44.7231 71.4746 37.4478 62.5 37.4478C53.5254 37.4478 46.25 44.7231 46.25 53.6978C46.25 62.6724 53.5254 69.9478 62.5 69.9478Z"
                        stroke="#F15A22"
                        strokeWidth="7"
                    />
                    <path
                        d="M18.8542 44.2186C29.1146 -0.885568 95.9375 -0.833483 106.146 44.2707C112.135 70.729 95.6771 93.1249 81.25 106.979C70.7813 117.083 54.2188 117.083 43.6979 106.979C29.3229 93.1249 12.8646 70.6769 18.8542 44.2186Z"
                        stroke="#F15A22"
                        strokeWidth="7"
                    />
                </svg>
                <h2>ثبت آدرس</h2>
                <div className="frame-rel">
                    <svg
                        width="26"
                        height="26"
                        viewBox="0 0 26 26"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <circle cx="13" cy="13" r="13" fill="#D9D9D9" />
                        <path
                            opacity="0.4"
                            d="M12.5 14.3937C13.577 14.3937 14.45 13.5206 14.45 12.4437C14.45 11.3667 13.577 10.4937 12.5 10.4937C11.4231 10.4937 10.55 11.3667 10.55 12.4437C10.55 13.5206 11.4231 14.3937 12.5 14.3937Z"
                            stroke="#F15A22"
                            strokeWidth="1.5"
                        />
                        <path
                            d="M7.26244 11.3063C8.49369 5.89375 16.5124 5.9 17.7374 11.3125C18.4562 14.4875 16.4812 17.175 14.7499 18.8375C13.4937 20.05 11.5062 20.05 10.2437 18.8375C8.51869 17.175 6.54369 14.4813 7.26244 11.3063Z"
                            stroke="#F15A22"
                            strokeWidth="1.5"
                        />
                    </svg>
                    <Map
                        style={{ height: "calc(100vh - 260px)" }}
                        initialViewState={{
                            longitude: 51.375433528216654,
                            latitude: 35.73356434056531,
                            zoom: 11,
                        }}
                        mapboxAccessToken="pk.eyJ1IjoiYWxkZjkyIiwiYSI6ImNscHh5ZG56dTByMXAycnJ2cDNmdDQ5M3YifQ.a_sUt1rLFMfA0jHrETcM7A"
                        mapStyle="mapbox://styles/mapbox/streets-v11"
                        transformRequest={(url) => {
                            return {
                                url,
                            };
                        }}
                        onClick={handleMapClick}
                    >
                        <GeolocateControl />
                        {selectedLocation && (
                            <Marker
                                latitude={selectedLocation.lat}
                                longitude={selectedLocation.lng}
                                offsetLeft={-20}
                                offsetTop={-10}
                            >
                                <svg
                                    width="24"
                                    height="27"
                                    viewBox="0 0 57 65"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M55.4409 21.4062C52.1597 6.96875 39.5659 0.46875 28.5034 0.46875C28.5034 0.46875 28.5034 0.46875 28.4722 0.46875C17.4409 0.46875 4.81585 6.9375 1.5346 21.375C-2.12165 37.5 7.75335 51.1562 16.6909 59.75C20.0034 62.9375 24.2534 64.5312 28.5034 64.5312C32.7534 64.5312 37.0034 62.9375 40.2847 59.75C49.2222 51.1562 59.0972 37.5312 55.4409 21.4062ZM28.5034 37.0625C23.0659 37.0625 18.6596 32.6562 18.6596 27.2188C18.6596 21.7813 23.0659 17.375 28.5034 17.375C33.9409 17.375 38.3472 21.7813 38.3472 27.2188C38.3472 32.6562 33.9409 37.0625 28.5034 37.0625Z"
                                        fill="#1AA3B9"
                                    />
                                </svg>
                            </Marker>
                        )}
                    </Map>
                </div>
                <select
                    onChange={(e) => {
                        setStateId(e.target.value);
                        getCitysHandler(e.target.value);
                    }}
                    className="select-loc"
                    name="state"
                >
                    <option value="" selected disabled>
                        استان
                    </option>
                    {allStates &&
                        allStates.length !== 0 &&
                        allStates.map((item) => {
                            return <option value={item.id}>{item.name}</option>;
                        })}
                </select>
                <select
                    onChange={(e) => {
                        setCityId(e.target.value);
                        getRegionsHandler(e.target.value);
                    }}
                    className="select-loc"
                    name="city"
                >
                    <option value="" selected disabled>
                        شهر
                    </option>
                    {allCitys &&
                        allCitys.length !== 0 &&
                        allCitys.map((item) => {
                            return <option value={item.id}>{item.name}</option>;
                        })}
                </select>
                <select
                    onChange={(e) => {
                        setRegion(e.target.value);
                        getDistrictHandler(e.target.value);
                    }}
                    className="select-loc"
                >
                    <option value="" selected disabled>
                        منطقه شهرداری
                    </option>
                    {allRegions &&
                        allRegions.length !== 0 &&
                        allRegions.map((item) => {
                            return (
                                <option
                                    selected={item.id == region}
                                    value={item.id}
                                >
                                    {item.name}
                                </option>
                            );
                        })}
                </select>
                <div className="btns">
                    <a onClick={() => navigate("/")}>
                        رد کن
                        <svg
                            width="9"
                            height="15"
                            viewBox="0 0 9 15"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M7 2L1.80417 6.76285C1.3718 7.15918 1.3718 7.84082 1.80417 8.23715L7 13"
                                stroke="white"
                                strokeWidth="2.5"
                                strokeLinecap="round"
                            />
                        </svg>
                    </a>
                    <button onClick={locationHandler}>ادامه</button>
                </div>
            </div>
        </div>
    );
};

export default SetLocation;
